/**
 * Logs analytics debug messages to console if enabled in runtime config.
 */
export function logDebugAnalytics(...messages: unknown[]) {
    const runtimeConfig = useRuntimeConfig();
    if (runtimeConfig.public.logDebug.analytics) {
        logDebug(...messages);
    }
}

/**
 * Logs product-watcher change debug messages to console if enabled in runtime config.
 */
export function logDebugProductChanges(...messages: unknown[]) {
    const runtimeConfig = useRuntimeConfig();
    if (runtimeConfig.public.logDebug.productChanges) {
        logDebug(...messages);
    }
}

/**
 * Log debug messages (only in dev mode)
 */
export function logDebug(...messages: unknown[]) {
    if (import.meta.dev || import.meta.env.VITEST) {
        // eslint-disable-next-line no-console
        console.debug(...messages);
    }
}
